var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('plaka',{attrs:{"rules":[(v) => !!v || 'Lütfen bu alanı doldurun.'],"label":"Plaka"},on:{"input":_vm.input},model:{value:(_vm.localValue.plaka),callback:function ($$v) {_vm.$set(_vm.localValue, "plaka", $$v)},expression:"localValue.plaka"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }